import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5e4c6de1&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=5e4c6de1&prod&lang=scss&scoped=true&"
import style1 from "./App.vue?vue&type=style&index=1&id=5e4c6de1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c6de1",
  null
  
)

export default component.exports